import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
const defaultState = {
    isLoading: true,
    isInitialized: false,
    isError: false
};
const actionHandlers = {
    [initialize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isLoading: true,
            isInitialized: false,
            isError: false
        }),
    [requestFailure.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isLoading: false,
            isError: true,
            isInitialized: true
        }),
    [requestSuccess.toString()] (state, { payload }) {
        return _object_spread_props(_object_spread({}, state), {
            isLoading: false,
            isInitialized: true,
            data: payload.data
        });
    }
};
const reducers = {
    [reduxKey]: (state = defaultState, action)=>{
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    }
};
export default reducers;

//# sourceMappingURL=reducers.js.map